<template>
  <div class="property_wrap">
    <div class="pro_top">标题栏设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {};
  }
};
</script>

